import { render, staticRenderFns } from "./address-parse.vue?vue&type=template&id=137c3c70&scoped=true"
import script from "./address-parse.vue?vue&type=script&lang=tsx"
export * from "./address-parse.vue?vue&type=script&lang=tsx"
import style0 from "./address-parse.vue?vue&type=style&index=0&id=137c3c70&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137c3c70",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/frontend_page_elephant/frontend_page_elephant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('137c3c70')) {
      api.createRecord('137c3c70', component.options)
    } else {
      api.reload('137c3c70', component.options)
    }
    module.hot.accept("./address-parse.vue?vue&type=template&id=137c3c70&scoped=true", function () {
      api.rerender('137c3c70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/warehouse/tools/address-parse.vue"
export default component.exports